import styled from 'styled-components';
import { generateMedia } from 'styled-media-query';

const customMedia = generateMedia({
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

export const DevLink = styled.a`
  ${'' /* text-transform: uppercase; */}
  letter-spacing: .5px;
  cursor: pointer;
  
  :hover {
    text-decoration: underline;
  }
`